module.exports = __webpack_public_path__ + "img/auth_google.084a49f0.svg";